import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { GroupStatus, type Group } from '@/types/api/group';
import z from 'zod';

export const ListGroupsSortKeySchema = z.enum(['name', 'createdAt', 'updatedAt']);

export const ListGroupsParamsSchema = z
  .object({
    name: z.string(),
    status: z.array(z.nativeEnum(GroupStatus)),
    groupId: z.string(),
  })
  .partial();

export type ListGroupsParams = z.infer<typeof ListGroupsParamsSchema>;

export const listGroups = async (params: ListGroupsParams): Promise<Group[]> => {
  return (await api.get(`/groups`, { params })).data;
};

export const listGroupsQueryOptions = (params: ListGroupsParams = {}) => {
  return queryOptions({
    queryKey: ['groups', params],
    queryFn: () => listGroups(params),
  });
};

type UseGroupsOptions = {
  queryConfig?: QueryConfig<typeof listGroupsQueryOptions>;
  params?: ListGroupsParams;
};

export const useGroupsSuspense = ({ queryConfig, params }: UseGroupsOptions) => {
  return useSuspenseQuery({
    ...listGroupsQueryOptions(params),
    ...queryConfig,
  });
};
